module.exports = __webpack_public_path__ + "static/img/robot-red-x2.78933ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/robot-red-x2.png
// module id = Yq/F
// module chunks = 1